var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleTagManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9135 21.0986L9.09473 17.3749L17.2961 9L21.2499 12.8749L12.9135 21.0986Z",
    fill: "#8AB4F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9296 4.63494L9.12451 0.75L0.804386 8.99113C-0.268129 10.0636 -0.268129 11.8023 0.804386 12.8761L8.9995 21.1247L12.8746 17.4998L6.63072 10.9336L12.9296 4.63494Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1947 9.05518L12.9446 0.805301C11.8709 -0.268434 10.1296 -0.268434 9.05581 0.805301C7.98205 1.87904 7.98205 3.62026 9.05581 4.694L17.3059 12.9439C18.3797 14.0176 20.121 14.0176 21.1947 12.9439C22.2685 11.8701 22.2685 10.1289 21.1947 9.05518Z",
    fill: "#8AB4F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9371 21.9999C12.4213 21.9999 13.6246 20.7967 13.6246 19.3125C13.6246 17.8282 12.4213 16.625 10.9371 16.625C9.45276 16.625 8.24951 17.8282 8.24951 19.3125C8.24951 20.7967 9.45276 21.9999 10.9371 21.9999Z",
    fill: "#246FDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleTagManager);
export default __webpack_public_path__ + "static/media/google-tag-manager.a2585525b2c472e5674676ac3157f245.svg";
export { ForwardRef as ReactComponent };